import styled from "styled-components";
import {colors, devices} from "../../utils/styled/_variables.styled";

export const InfiosFilter = styled.div`
    .filter {
        width: 100%;
        padding: 28px 0px 18px;
        margin: 0 auto;
        border-bottom: 1px solid ${colors.gray2};
        display: flex;
        flex-direction: column;
        align-items: center;

        @media ${devices.tabletSmall} {
            padding: 28px 0 18px 0px;
        }
    }
`;

export const InfiosTopWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: ${props => props.fullWidth === 'fullwidth' ? 'none' : '870px'};
    justify-content: space-between;
    margin-bottom: 32px;

    @media ${devices.tablets} {
        max-width: 100%
    }

    @media ${devices.tabletSmall} {
        padding-right: 30px;
    }
`;

export const InfiosFilterTitle = styled.h4`
    font-size: 24px;
`;

export const InfiosClearFilter = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;

    span {
        font-size: 19px;
        line-height: 16px;
        color: ${colors.blue};
        font-weight: 600;
        margin-top: 2px;
        transition: color 300ms ease;
    }

    svg {
        transition: transform 300ms ease;

        path {
            transition: fill 300ms ease;
        }
    }

    &:hover {
        span {
            color: ${colors.blueHover};
        }

        svg {
            transform: rotate(-60deg);

            path {
                fill: ${colors.blueHover};
            }
        }
    }
`;

export const InfiosFilterEffectWrapper = styled.div`
    width: 100%;
    position: relative;
    max-width: ${props => props.fullWidth === 'fullwidth' ? 'none' : '870px'};

    @media ${devices.tablets} {
        max-width: 100%
    }

    .filter__shadow {
        position: absolute;
        z-index: 2;
        width: 100%;
    }

    .shadow--left {
        content: "";
        position: absolute;
        height: 50px;
        width: 50px;
        left: 0;
        top: 0;
        pointer-events: none;

        background-image: linear-gradient(
                to left,
                rgba(255, 0, 0, 0),
                rgba(255, 255, 255, 1)
        );
    }

    .shadow--right {
        content: "";
        position: absolute;
        height: 50px;
        width: 50px;
        right: -2px;
        top: 0;
        pointer-events: none;

        background-image: linear-gradient(
                to right,
                rgba(255, 0, 0, 0),
                rgba(255, 255, 255, 1)
        );
    }
`;

export const InfiosFilterWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 16px;
    padding-bottom: 10px;
    position: relative;

    &.open {
        @media ${devices.tabletSmall} {
            top: 0;
            left: 0;
            position: fixed;
            z-index: 10;
            width: 100%;
            max-width: unset;
            height: 100%;
            display: inline;
            margin: 0;
            padding: 0;

            .filter__button {
                display: none;
            }

            .filter__box {
                max-height: unset;
                width: 100%;
                height: 100%;
                position: relative;
                top: 0;
            }
        }

    }

    @media ${devices.tabletSmall} {
        overflow-x: auto;
    }
`;

export const InfiosFilterItem = styled.div`
    display: ${props => props.hasOneItem ? "none" : "unset"};
    position: relative;
    width: 100%;
    max-width: 50%;

    @media ${devices.tabletLarge} {
        min-width: 205px;
    }

    @media ${devices.mobile} {
        min-width: 246px;
    }

    .filter__button {
        padding: 12px;
        background-color: ${props => props.backgroundColor ? props.backgroundColor : (props.open || props.hasChecked ? colors.infiosGray : colors.blueLight)};
        width: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        border: none;
        height: 48px;
        font-weight: 500;
        transition: background-color 300ms ease;

        .infios__filter__type {
            font-size: 19px;
            pointer-events: none;
            color: ${props => props.textColor ? props.textColor : (props.open || props.hasChecked ? colors.white : colors.infiosGray)};
            max-width: 85%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: inherit;
            transition: color 300ms ease;
        }

    }

    .filter__icon {
        & > svg {
            height: 12px;
            position: absolute;
            transform: ${props => props.open ? 'rotate(270deg)' : 'rotate(90deg)'};
            right: 20px;
            top: 18px;
            pointer-events: none;
            cursor: pointer;
            transition: transform 300ms ease;

            path {
                fill: ${props => props.textColor ? props.textColor : (props.open || props.hasChecked ? colors.white : colors.infiosGray)};
                transition: fill 300ms ease;
            }
        }

        .close__round {
            height: 16px;
            right: 15px;
            top: 16px;
            pointer-events: all;
        }
    }

    &:hover {
        .filter__button {
            background-color: ${props => props.hoverBackgroundColor ? props.hoverBackgroundColor : colors.infiosGray};

            .infios__filter__type {
                color: ${props => props.hoverTextColor ? props.hoverTextColor : colors.white};
            }
        }

        .filter__icon {
            & > svg {
                path {
                    fill: ${props => props.hoverTextColor ? props.hoverTextColor : colors.white};
                }
            }
        }
    }


    .filter__box {
        z-index: 3;
        position: absolute;
        width: 420px;
        top: 55px;
        background-color: white;
        -webkit-filter: drop-shadow(0px 12px 48px rgba(0, 0, 0, 0.12));
        filter: drop-shadow(0px 12px 48px rgba(0, 0, 0, 0.12));
        opacity: 0;
        pointer-events: none;
        transition: opacity 300ms ease;
        display: flex;
        flex-direction: column;
        max-height: 400px;

        &.start {
            left: 0;
        }

        &.middle {
            left: 50%;
            transform: translateX(-50%);
        }

        &.end {
            right: 0;
        }

        .checkbox {
            pointer-events: inherit;
        }

        @media ${devices.mobileToDesktop} {
            width: 327px;
        }

        @media ${devices.tabletSmall} {
            position: fixed;
            z-index: 10;
            inset: 0;
            max-height: none;
            width: 100%;

            .checkbox {
                pointer-events: inherit;
            }
        }

        &.active {
            opacity: 1;
            pointer-events: all;
        }

        & > button {
            background: none;
            border: none;
            padding: 0;
            margin: 0;
            font: inherit;
            color: inherit;
            text-align: inherit;
            outline: none;
            height: 14px;
            position: fixed;
            display: inline;
            z-index: 11;
            right: 17px;
            top: 17px;
            cursor: pointer;
            @media ${devices.tabletSmall} {
                top: 29px;
            }
        }

        .inner__box {
            padding: 11px 11px 23px 11px;
            width: 100%;
            border: 1px solid #E6E2DC;

            @media ${devices.tabletSmall} {
                padding: 24px;
                border: unset;
                border-bottom: 1px solid #E6E2DC;
            }

            &.inner__box-full {
                flex: 1;
                overflow-y: auto;
            }

            &:last-child {
                border-top: none;
            }

            button {
                width: 100%;
            }
        }

        .filter__box_title {
            margin-bottom: 16px;
            font-size: 19px;
        }

        .filter__box_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
        }

        .filter__box_item-amount {
            font-size: 19px;
            color: ${colors.gray5};
            margin-top: 8px;
        }
    }
`;

export const SkeletonWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 80px 0;
    row-gap: 60px;
    column-gap: 40px;
    margin-top: 40px;

    @media ${devices.tabletLarge} {
        grid-template-columns: 1fr 1fr;
        row-gap: 64px;
    }

    @media ${devices.mobile} {
        grid-template-columns: 1fr;
        row-gap: 56px;
    }
`;
